import { FC, useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Button, DatePicker, Form, Input, message, Radio } from "antd";

import { useTranslation } from "react-i18next";

import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "antd/es/form/Form";
import activityService from "../../../module/activity/service/activity.service";
import moment from "moment";
import { UploadImg } from "../../../common/components/UploadImg";
import { MultiSelectSite } from "../../../module/site/component/multi.select.site";
import { SelectCity } from "../../../module/overview/components/select.city.all";
import MyEditor from "../../../common/components/MyEditor";

export const CouponActivityDetail: FC = () => {
	const { TextArea } = Input;
	const navigate = useNavigate();
	const { t } = useTranslation();
	const params = useParams();
	const [form] = useForm();
	const [editorLoading, setEditorLoading] = useState<boolean>(false);


	useEffect(() => {
		if (params.id) {
			activityService.detail(Number(params.id)).then((res) => {
				if (res.data.code === 200) {
					console.log(res.data.data);			
					form.setFieldsValue({
						...res.data.data,
						activityTime: [moment(res.data.data.beginTime), moment(res.data.data.endTime)],
						activityArea: [res.data.data.provinceId, res.data.data.cityId, res.data.data.districtId],
					});
					setEditorLoading(true);
				}
				
			});
		} else {
			setEditorLoading(true);
		}
	}, [form, params.id]);



	const onFinish = async (value: any) => {
		const param = {
			...value,
			activityArea: undefined,
			provinceId: value.activityArea && value.activityArea[0],
			cityId: value.activityArea && value.activityArea[1],
			districtId: value.activityArea && value.activityArea[2],
			activityTime: undefined,
			beginDate: value.activityTime[0].format("YYYY-MM-DD") + " 00:00:00",
			endDate: value.activityTime[1].format("YYYY-MM-DD") + " 23:59:59",
			type: 3,
		};
		if (!params.id) {
			const { data } = await activityService.add(param);
			if (data.code === 200) {
				message.success(t("success"));
				navigate("/activity/coupon");
			} else {
				message.error(data.msg);
			}
		} else {
			const { data } = await activityService.update({
				...param,
				id: Number(params.id),
			});
			if (data.code === 200) {
				message.success(t("success"));
				navigate("/activity/coupon");
			} else {
				message.error(data.msg);
			}
		}
	};

	return (
		<Container>
			<Form labelCol={{ span: 4 }} wrapperCol={{ span: 12 }} style={{ padding: 20 }} onFinish={onFinish} form={form}>
				<Form.Item label={t("image")} name='imageUrl'>
					<UploadImg />
				</Form.Item>

				<Form.Item label={t("activityName")} name='title'>
					<Input placeholder={t("activityName")} />
				</Form.Item>

				<Form.Item label={t("activityArea")} name='activityArea'>
					<SelectCity useArray />
				</Form.Item>
				<Form.Item label={t("sort")} name='sort'>
					<Input placeholder={t("sort")} />
				</Form.Item>
				<Form.Item label={t("shopName")} name='shopId'>
					<MultiSelectSite />
				</Form.Item>
				<Form.Item label={t("activityTime")} name='activityTime'>
					<DatePicker.RangePicker />
				</Form.Item>
				<Form.Item label={t("couponCode")} name='code'>
					<Input />
				</Form.Item>
				<Form.Item label={t("status")} name='status'>
					<Radio.Group>
						<Radio value={1}>{t("onSale")}</Radio>
						<Radio value={2}>{t("off")}</Radio>
					</Radio.Group>
				</Form.Item>
				<Form.Item label={t("isHomePageShow")} name='isHomePageShow'>
					<Radio.Group>
						<Radio value={0}>{t("no")}</Radio>
						<Radio value={1}>{t("yes")}</Radio>
					</Radio.Group>
				</Form.Item>
				<Form.Item label={t("activityBriefly")} name='sketch'>
					<TextArea rows={4} placeholder={t("activityBriefly")} />
				</Form.Item>
				<Form.Item label={t("activityRule")} name='rule'>
					{editorLoading && <MyEditor />}
				</Form.Item>
				<Form.Item label={t("activityContent")} name='content'>
					{editorLoading && <MyEditor />}
				</Form.Item>
				<Form.Item wrapperCol={{ span: 12, offset: 4 }}>
					<Button type='primary' htmlType='submit'>
						{t("submit")}
					</Button>
				</Form.Item>
			</Form>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;
`;
